import { env } from '@/config/env';
import { notifications } from '@mantine/notifications';
import { IconX } from '@tabler/icons-react';
import Axios, { InternalAxiosRequestConfig } from 'axios';

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = 'application/json application/octet-stream';
  }

  config.withCredentials = true;
  return config;
}


export const api = Axios.create({
  baseURL: env.API_URL
});



api.interceptors.request.use(authRequestInterceptor);
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    //console.log(error);
    if (error.response?.status === 401) {
      return Promise.reject(error);
    }
    const xIcon = <IconX size={20} />;

    // Extract error message from response
    // Handle both JSON responses with message property and plain text responses
    let message = 'An unexpected error occurred';
    const responseData = error.response?.data;

    if (responseData) {
      if (typeof responseData === 'string') {
        // Plain text response
        message = responseData;
      } else if (typeof responseData === 'object' && responseData.message) {
        // JSON response with message property
        message = responseData.message;
      } else if (typeof responseData === 'object' && responseData.detail) {
        // RFC 7807 problem+json bodies use `detail` instead of `message`
        // (e.g., 402/409/500/502 from ASP.NET ControllerBase.Problem()).
        message = responseData.detail;
      }
    } else if (error.message) {
      // Fallback to axios error message, but provide a better default
      message = error.message;
    }

    notifications.show({
      title: 'Error',
      message,
      icon: xIcon,
      color: 'red',
      "aria-live": "polite",
      closeButtonProps: {
        "aria-label": "Close error notification"
      }
    })
    return Promise.reject(error);
  }
);
